import React from "react";
import { Alert } from "@mui/material";
import { useAdminDataGuard } from "../hooks/useAdminDataGuard";
import AccountsList from "../components/accounts/AccountsList";

const AdminAccountsPage = () => {
  const canAccessAdminData = useAdminDataGuard();

  if (!canAccessAdminData) {
    return <Alert severity='error'>Admin token validation failed.</Alert>;
  }

  return <AccountsList />;
};

export default AdminAccountsPage;
